import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.8601 40.52C73.8601 40.52 60.3001 33.63 56.2501 28.9C51.7501 23.64 51.9501 1 51.9501 1H39.5301C39.5301 1 39.8401 23.75 35.2301 28.9C30.3401 34.36 17.6201 40.32 17.6201 40.32C23.8101 54.9 36.2101 58.62 45.7401 58.62C55.2701 58.61 67.6701 55.1 73.8601 40.52Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.3904 57.4199C85.8304 45.4099 82.1804 42.1699 77.5104 39.8199C75.2104 38.6599 60.6804 30.9399 60.6804 30.9399C60.6804 30.9399 55.7704 37.8799 46.0904 37.8799C36.4104 37.8799 30.7904 30.9399 30.7904 30.9399C30.7904 30.9399 16.3504 38.6099 13.9504 39.8199C9.28039 42.1699 5.72039 45.7999 4.07039 57.4199C2.59039 68.4799 2.15039 71.2399 2.15039 71.2399H89.3004C89.3104 71.2299 88.7004 67.7099 87.3904 57.4199Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.8506 33.75C24.8506 33.75 31.1006 43.99 44.8306 43.99C60.0206 43.99 66.6306 33.75 66.6306 33.75"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path d="M76.4506 70.86L59.8506 40.28" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M31.2005 39.95L15.0205 70.64" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M41.8408 43.78L45.7408 50.53L49.6308 43.78"
        stroke={outline}
        fill="none"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.7371"
          y1="42.17"
          x2="45.7371"
          y2="8.1373"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
